import Image from 'next/image'
import '../../sass/menu/Header.scss'
import { teko } from '@/lib/fonts'
import { ISocial, Language } from '@/lib/interfaces/interfaces'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import LanguageFlag from './LanguageFlag'
import GeneratedLogo from '../GeneratedLogo'

interface Props {
	headerBgImg?: string
	logo?: string
	name: string
	socials?: ISocial[]
  menuTheme: string
  menuSub: boolean
  slug: string
  language: Language
  activeTranslations: boolean
  defaultLanguage: Language
  activeLanguages: Language[]
  showMenuTitle?: boolean
  showMenuLogo?: boolean
}

const Header = ({ headerBgImg, logo, name, socials, menuTheme, menuSub, slug, language, activeTranslations, defaultLanguage, activeLanguages, showMenuTitle, showMenuLogo }: Props) => {
  const placeHolderImg = `/img/default-headers/${menuTheme}.png`
  const backgroundStyle = {
    backgroundImage: `url(${headerBgImg || placeHolderImg})`,
    backgroundSize: headerBgImg ? 'cover' : 'auto 100%',
    width: '100%',
    height: '250px'
  }

  const socialIcons = {
    instagram: faInstagram,
    facebook: faFacebook
  }

  return (
    <header className='page-header' style={backgroundStyle}>
      {menuSub && activeTranslations && <LanguageFlag language={language} slug={slug} defaultLanguage={defaultLanguage} activeLanguages={activeLanguages} />}
      <div className='logo-container'>
        {showMenuLogo !== false && (
          logo
            ? <Image className='logo-img' src={logo} alt={`logo de ${name}`} fill sizes='(max-width: 768px) 300px, 300px' priority />
            : <GeneratedLogo name={name} className='logo-img' />
        )}
      </div>
      {socials && (
        <div className='socials'>
          {socials.map((social, index) => {
            const Icon = socialIcons[social.name]
            return Icon
              ? (
                <a key={index} href={social.url} target='_blank' rel='noreferrer'>
                  <FontAwesomeIcon icon={Icon} />
                </a>
                )
              : null
          })}
        </div>
      )}
      {showMenuTitle !== false && (
        <h1 className={teko.className}>{language === 'en' ? `${name}'s Menu` : language === 'fr' ? `Menu de ${name}` : language === 'eu' ? `${name} menua` : `Menú de ${name}`}</h1>
      )}
    </header>
  )
}

export default Header
